export default {"src":"/_next/static/media/question-circle.b7f78ca9.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};